<div class="grupo-content pt-3">
  @if (grupo.formulas.length > 0) {
    <div class="formulas-grid">
      @for (formula of grupo.formulas; track formula.chaveFormula) {
        @let versoes = versoesFormula(formula);
        @if (versoes.length > 0) {
        <div class="formula-versoes">
          @for (modelo of versoes; track modelo.chaveFormulaModelo + modelo.dataVigenciaInicio) {
            @if (!$first) {
            <div class="formula-card-ligacao" aria-hidden="true"></div>
            }
            <app-formula-card
              [formula]="formula"
              [modeloExibicao]="modelo"
              [recolhivel]="!versaoEhAtual(formula, modelo)"
              [modo]="modoListagem"
              [permitirAlteracaoModeloEmpresa]="permitirAlteracaoModeloEmpresa"
              (modeloEmpresaSelecionado)="selecionarModeloEmpresa(formula, $event)">
            </app-formula-card>
          }
        </div>
        } @else {
        <app-formula-card
          [formula]="formula"
          [modo]="modoListagem"
          [permitirAlteracaoModeloEmpresa]="permitirAlteracaoModeloEmpresa"
          (modeloEmpresaSelecionado)="selecionarModeloEmpresa(formula, $event)">
        </app-formula-card>
        }
      }
    </div>
  }

  @for (filho of filhosComFormulas(grupo); track filho.chave) {
    <mat-expansion-panel [expanded]="true" class="formula-grupo-panel mb-3">
      <mat-expansion-panel-header class="formula-grupo-header">
        <mat-panel-title class="formula-grupo-titulo">{{ filho.grupo }}</mat-panel-title>
        <mat-panel-description class="formula-grupo-descricao">
          <span class="status-badge status-qtd" [ngClass]="badgeClasses.quantidade">
            {{ quantidadeFormulas(filho) }} fórmula(s)
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <app-formula-grupo
        [grupo]="filho"
        [permitirAlteracaoModeloEmpresa]="permitirAlteracaoModeloEmpresa"
        (modeloEmpresaSelecionado)="modeloEmpresaSelecionado.emit($event)">
      </app-formula-grupo>
    </mat-expansion-panel>
  }
</div>
